import { createSlice } from "@reduxjs/toolkit"
import {
  addVehicle,
  deleteVehicle,
  getAllVehicles,
  getVehicleDetails,
  updateVehicle,
  updateVehicleStatus,
} from "store/actions/vehicleAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  totalCount: null,
  vehicles: [],
  vehicleDetails: {},
}

const usersSlice = createSlice({
  name: "allergens",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL ALLERGENS
    builder
      .addCase(getAllVehicles.pending, state => {
        state.loading = true
      })
      .addCase(getAllVehicles.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.vehicles = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllVehicles.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(addVehicle.pending, state => {
        state.isLoading = true
      })
      .addCase(addVehicle.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addVehicle.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(updateVehicle.pending, state => {
        state.isLoading = true
      })
      .addCase(updateVehicle.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateVehicle.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(updateVehicleStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateVehicleStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload || {}
        if (status) {
          const { id, status } = action.meta.arg
          state.vehicles = state.vehicles.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateVehicleStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getVehicleDetails.pending, state => {
        state.loading = true
        state.allergenDetails = {}
      })
      .addCase(getVehicleDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.vehicleDetails = data
        }
      })
      .addCase(getVehicleDetails.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(deleteVehicle.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteVehicle.fulfilled, (state, action) => {
        const { status, msg } = action.payload || {}
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.vehicles = state.vehicles.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteVehicle.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
